import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_BASEURL}`;
const baseCfdiUrl = `${process.env.VUE_APP_BASECFDIURL}`;

export default axios.create({
  baseURL: baseUrl,
});

export const cfdiAxios = axios.create({
  baseURL: baseCfdiUrl,
});
